export const NotFound = () => {
    return (
        <div>
            not found
        </div>
    )
}